export const InstitutionalInformationActionTypes = {
    SET_INSTITUTIONAL_INFORMATION: ' SET_INSTITUTIONAL_INFORMATION'
}